import type { ProofStatus } from 'src/shared/utils/proofUrls'

export const statusLabel = (
  status: ProofStatus,
  t: (en: string, sv?: string) => string
) => {
  switch (status) {
    case 'pending':
      return t('Pending review', 'Väntar på granskning')
    case 'not_approved':
      return t('Changes requested', 'Ändringar begärda')
    case 'approved':
      return t('Approved', 'Godkänd')
    default:
      return status
  }
}

export const statusBadgeVariant = (
  status: ProofStatus
): 'yellow' | 'green' | 'red' | 'secondary' => {
  switch (status) {
    case 'pending':
      return 'yellow'
    case 'approved':
      return 'green'
    case 'not_approved':
      return 'red'
    default:
      return 'secondary'
  }
}
